import { Component } from '@angular/core';
import { Router } from '@angular/router';
import { ToastController } from '@ionic/angular';
import { Auth, signOut } from '@angular/fire/auth';
import { TripService } from './shared/data-access/trip.service';
import { Observable } from 'rxjs';

@Component({
    selector: 'app-root',
    templateUrl: 'app.component.html',
    styleUrls: ['app.component.scss'],
    standalone: false
})
export class AppComponent {

  tripId$: Observable<string>;
  errorMessage: string;

  constructor(
    private router: Router,
    private toastCtrl: ToastController,
    private auth: Auth,
    private tripService: TripService
  ) {
    this.tripId$ = this.tripService.getActiveTripIdForLoggedInUser()
  } 

  logout = async () => {
    try {
      await signOut(this.auth);
      this.router.navigateByUrl('login');
      // location.reload();
    } catch (error) {
      // Handle error
    }
  };

  async showToast(message: string, duration?: number, isError: boolean = false) {
    const toast = await this.toastCtrl.create({
      message,
      duration,
      position: 'bottom',
      cssClass: isError ? 'toast-error' : '',
      buttons: [
        {
          text: 'Close',
          role: 'cancel',
        }
      ]
    });
    toast.present();
  }
}
